import Collapse from '../Collapse';

export default {
  name: 'Subgroup',
  components: {
    Collapse,
  },
  props: {
    subgroups: {
      type: Array,
      required: true,
    },
    documentSlug: {
      type: String,
      default: '',
    },
    className: {
      type: String,
    },
  },
};
